import client from './client';

// 'report' sonuçları sunucudan gelmez; GlobalSearch içinde PDF_REPORTS listesinden üretilir.
export type GlobalSearchType = 'powerplant' | 'site' | 'investor' | 'inverter' | 'sensor' | 'report';

export interface GlobalSearchResult {
  type: GlobalSearchType;
  id: string;
  title: string;
  subtitle: string | null;
}

export async function fetchGlobalSearch(q: string, signal?: AbortSignal): Promise<GlobalSearchResult[]> {
  const { data } = await client.get<{ results: GlobalSearchResult[] }>('/search', { params: { q }, signal });
  return data.results;
}
